import {ChangeDetectorRef, Injector} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PlayerBaseService} from '../../services/PlayerService/player.base.service';
import {Subject} from 'rxjs';
import {ILogInfo} from "../../interfaces/ILogInfo";


export class RegDialogComponent {
  playerService: PlayerBaseService;
  http: HttpClient;
  changeDetectorRef;
  click$ = new Subject();
  blockUI = false;

  constructor(protected injector: Injector) {
    this.playerService = injector.get('playerService');
    this.changeDetectorRef = this.injector.get(ChangeDetectorRef);
    this.http = this.injector.get(HttpClient);
  }

  onClick() {
    this.click$.next('click');
  }

  disableUI(value) {
    this.blockUI = value;
    this.changeDetectorRef.detectChanges();
  }
}

